/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Memory } from './Memory';
import {
    MemoryFromJSON,
    MemoryFromJSONTyped,
    MemoryToJSON,
} from './Memory';

/**
 * 
 * @export
 * @interface GetMemories200Response
 */
export interface GetMemories200Response {
    /**
     * 
     * @type {Array<Memory>}
     * @memberof GetMemories200Response
     */
    memories: Array<Memory>;
    /**
     * 
     * @type {boolean}
     * @memberof GetMemories200Response
     */
    hasNextMemory: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMemories200Response
     */
    nextPageToken?: string;
}

/**
 * Check if a given object implements the GetMemories200Response interface.
 */
export function instanceOfGetMemories200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "memories" in value;
    isInstance = isInstance && "hasNextMemory" in value;

    return isInstance;
}

export function GetMemories200ResponseFromJSON(json: any): GetMemories200Response {
    return GetMemories200ResponseFromJSONTyped(json, false);
}

export function GetMemories200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMemories200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memories': ((json['memories'] as Array<any>).map(MemoryFromJSON)),
        'hasNextMemory': json['hasNextMemory'],
        'nextPageToken': !exists(json, 'nextPageToken') ? undefined : json['nextPageToken'],
    };
}

export function GetMemories200ResponseToJSON(value?: GetMemories200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memories': ((value.memories as Array<any>).map(MemoryToJSON)),
        'hasNextMemory': value.hasNextMemory,
        'nextPageToken': value.nextPageToken,
    };
}

